import { Injectable } from '@angular/core';
import { keycloak } from '../../../config/keycloak.config';
import { LocalService } from '../storage/local.service';
import { UserService } from '../../pages/user/services/user.service';
import { SsoServiceService } from '../sso-service.service';
import { from } from 'rxjs';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private readonly localService: LocalService,
    private readonly userService: UserService,
    private readonly ssoService: SsoServiceService,
    private readonly router: Router,
    private readonly cookieService: CookieService,
  ) {}

  isAuthenticated(): boolean {
    const type = this.localService.getItem('userType');
    if (type === 'seller' || type === 'seller_admin') {
      this.localService.setItem('type', 'keycloak');
      return keycloak.authenticated || false;
    } else if (type === 'operator' || type === 'operator_admin') {
      return true;
    } else if (type == 'sso') {
      this.localService.setItem('type', 'sso');
      return this.ssoService.isLoggedIn;
    }
    return false;
  }

  get authenticationType() {
    return this.localService.getItem('type');
  }

  refreshToken(minValidity: number = 60) {
    return keycloak
      .updateToken(minValidity)
      .then(() => {
        return true;
      })
      .catch((error) => {
        console.error('Failed to refresh token', error);
        return false;
      });
  }

  login(type) {
    if (type === 'seller' || type === 'seller_admin') {
      keycloak.login();
      this.localService.setItem('token', keycloak.token);
      this.localService.setItem('type', 'keycloak');
    } else if (type == 'sso') {
      this.ssoService.login();
    } else {
      this.localService.setItem('type', 'azure');

      globalThis.location.reload();
    }
  }

  logout(error = false): void {
    let type = this.localService.getItem('userType');
    this.cookieService.deleteAll();
    this.localService.clear();

    if (type === 'seller' || type === 'seller_admin') {
      const redirectUri = error ? '/?error' : '/';
      if (keycloak.idToken) {
        const authUrl = keycloak.authServerUrl.endsWith('/') ? keycloak.authServerUrl : keycloak.authServerUrl + '/';
        const logoutUrl = `${authUrl}realms/${keycloak.realm}/protocol/openid-connect/logout?post_logout_redirect_uri=${encodeURIComponent(globalThis.location.origin + redirectUri)}&id_token_hint=${keycloak.idToken}`;
        globalThis.location.href = logoutUrl;
      } else {
        sessionStorage.clear();

        keycloak.clearToken();

        // Rediriger vers la page de login
        globalThis.location.href = redirectUri;
      }
    } else if (type == 'sso') {
      this.ssoService.logout();
    } else {
      globalThis.location.href = '/';
    }
  }

  getToken(): string {
    let type = this.localService.getItem('userType');
    if (type === 'seller_admin' || type == 'seller') {
      return keycloak.token;
    } else if (type === 'operator') {
      return 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJrZXljbG9hayIsImlhdCI6MTcyOTUxMzY0NSwiZXhwIjoxNzYxMDQ5NjQ1LCJhdWQiOiJ3d3cuZXhhbXBsZS5jb20iLCJzdWIiOiJqcm9ja2V0QGV4YW1wbGUuY29tIiwiZW1haWwiOiJ0ZXN0T3BlcmF0b3JAc2VsbGVyLmNvbSJ9.Yl2hUzrjSA3GOhdN8-b1ioi-aU0vgMKc53u8Ndwo378';
    } else if (type === 'operator_admin') {
      return 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJrZXljbG9hayIsImlhdCI6MTcyOTUxMzY0NSwiZXhwIjoxNzYxMDQ5NjQ1LCJhdWQiOiJ3d3cuZXhhbXBsZS5jb20iLCJzdWIiOiJqcm9ja2V0QGV4YW1wbGUuY29tIiwiZW1haWwiOiJvcGVyYXRvckBhZG1pbi5jb20ifQ.nqltXIzn03OM9IA2gJMFPxzUBkCwnz9vZu21rcXhJNY';
    } else if (type == 'sso') {
      return this.ssoService.token;
    }
    return '';
  }

  isTokenExpired(): boolean {
    if (this.userService.hasRoleSeller()) {
      return keycloak.isTokenExpired(10);
    }
    return false;
  }

  updateToken() {
    return from(keycloak.updateToken(30));
  }
}
